import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
  disabled?: boolean;
}

function visiblePages(current: number, total: number): number[] {
  const count = Math.min(5, total);
  const start = Math.max(1, Math.min(current - 2, total - count + 1));
  return Array.from({ length: count }, (_, index) => start + index);
}

export function Pagination({ page, totalPages, onChange, disabled }: PaginationProps) {
  if (totalPages <= 1) return null;
  return (
    <nav className="clip-pagination" aria-label="Clips pagination">
      <button type="button" disabled={disabled || page === 1} onClick={() => onChange(page - 1)}>
        <FiChevronLeft aria-hidden="true" /> Previous
      </button>
      <div className="clip-page-numbers">
        {visiblePages(page, totalPages).map((pageNumber) => (
          <button
            type="button"
            key={pageNumber}
            className={pageNumber === page ? "active" : ""}
            aria-current={pageNumber === page ? "page" : undefined}
            disabled={disabled}
            onClick={() => onChange(pageNumber)}
          >
            {pageNumber}
          </button>
        ))}
      </div>
      <button type="button" disabled={disabled || page === totalPages} onClick={() => onChange(page + 1)}>
        Next <FiChevronRight aria-hidden="true" />
      </button>
    </nav>
  );
}
